import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import ServiceMap from "./sections/ServiceMap";
import Connect from "./sections/Connect";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Contact />
      <ServiceMap />
      <Connect />
      <Footer />
    </div>;
}